import { produce } from "immer";
import { Days } from "cadendar-shared";
import Button from "../../main/components/Button.tsx";
import IconButton from "../../main/components/IconButton.tsx";
import Delete02Icon from "../../main/icons/delete-02-stroke-rounded.tsx";

export interface HoraireLineEditProps {
  plages: { start: string; end: string }[];
  addPlage: () => void;
  removePlage: (position: number) => void;
  onSetPlages: (plages: { start: string; end: string }[]) => void;
  validationMap: { start: string[]; end: string[] }[];
  day: Days;
}

const HoraireLineEdit = (props: HoraireLineEditProps) => {
  const handleSetPlage = (
    startOrEnd: "start" | "end",
    position: number,
    value: string
  ) => {
    props.onSetPlages(
      produce(props.plages, (draft) => {
        draft[position][startOrEnd] = value;
      })
    );
  };
  return (
    <form className="flex flex-col gap-3" onSubmit={(event) => event.preventDefault()}>
      {props.plages.length === 0 ? (
        <div className="rounded-xl border border-dashed border-[var(--color-dark-grey)] bg-[#fafafa] p-4 text-[var(--color-quasi-black)]">
          Aucune plage. Ajoutez-en une pour ouvrir ce jour.
        </div>
      ) : null}

      {props.plages.map((plage, idx) => {
        const startErrors = props.validationMap[idx].start;
        const endErrors = props.validationMap[idx].end;

        return (
          <div
            className="rounded-xl border border-[#eadfb3] bg-[#fff7dc] p-3"
            key={props.day + idx + "key"}
          >
            <div className="mb-3 flex items-center justify-between gap-3 border-b border-[#ead29a] pb-2">
              <div className="text-[11px] font-semibold uppercase tracking-[0.1em] text-[#7a6331]">
                Plage {idx + 1}
              </div>
              <IconButton
                onClick={() => props.removePlage(idx)}
                tooltip="Supprimer cette plage"
                data-testid={"removeBornesButton" + props.day + idx}
                className="!h-8 !w-8 !min-h-8 !min-w-8 border border-[#f2c7c7] bg-[#fff5f5] text-[var(--color-pastel-red)] hover:brightness-95"
                size="small"
              >
                <Delete02Icon width={16} height={16} color="red" />
              </IconButton>
            </div>

            <div className="grid grid-cols-2 gap-3 max-sm:grid-cols-1">
              <div className="flex flex-col gap-1.5">
                <label
                  className="pl-1 text-xs font-semibold uppercase tracking-[0.04em] text-[#8d7442]"
                  htmlFor={"fromPlage" + idx}
                >
                  De
                </label>
                <input
                  type="text"
                  className={
                    "form-control min-h-10 w-full rounded-[10px] border bg-white px-3 py-2.5 text-[#1f2937] " +
                    (startErrors.length === 0
                      ? "border-[#d7c27f]"
                      : "border-[var(--color-pastel-red)] bg-[#fff4f4]")
                   }
                   value={plage.start}
                   placeholder="09:15 ou 9h15"
                   inputMode="numeric"
                  onChange={(event) =>
                    handleSetPlage("start", idx, event.currentTarget.value)
                  }
                  id={"fromPlage" + idx}
                  data-test={"horaireInputFrom" + props.day + idx}
                />
                {startErrors.length > 0 ? (
                  <div className="text-sm text-[var(--color-pastel-red)]">
                    {startErrors.join(", ")}
                  </div>
                ) : null}
              </div>

              <div className="flex flex-col gap-1.5">
                <label
                  className="pl-1 text-xs font-semibold uppercase tracking-[0.04em] text-[#8d7442]"
                  htmlFor={"toPlage" + props.day + idx}
                >
                  A
                </label>
                <input
                  type="text"
                  className={
                    "form-control min-h-10 w-full rounded-[10px] border bg-white px-3 py-2.5 text-[#1f2937] " +
                    (endErrors.length === 0
                      ? "border-[#d7c27f]"
                      : "border-[var(--color-pastel-red)] bg-[#fff4f4]")
                   }
                   value={plage.end}
                   placeholder="09:15 ou 9h15"
                   inputMode="numeric"
                  onChange={(event) =>
                    handleSetPlage("end", idx, event.currentTarget.value)
                  }
                  id={"toPlage" + props.day + idx}
                  data-test={"horaireInputTo" + props.day + idx}
                />
                {endErrors.length > 0 ? (
                  <div className="text-sm text-[var(--color-pastel-red)]">
                    {endErrors.join(", ")}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}

      <div className="flex flex-wrap gap-2">
        <Button
          onClick={props.addPlage}
          title="Ajouter une plage"
          style="secondary"
          size="small"
          data-testid={"addBornesButton" + props.day}
        />
      </div>
    </form>
  );
};

export default HoraireLineEdit;
